<div class="voicemail">
  <div class="vox-inline-message vox-inline-message_light-grey mb-3">
    <div>
      <i class="icon-small-info"></i>
      <span>
        {{ "events.company-call-history.details.voicemail.disclaimer" | Translate }}
      </span>
    </div>
  </div>
  <div class="voicemail__audio-player">
    <vox-audio-player [fileUrl]="callItem.voicemailUrl"></vox-audio-player>
    <button
      class="vox-btn vox-btn__secondary"
      (click)="openLink(callItem.voicemailUrl)">
      <i class="icon-small-download-audio"></i>
    </button>
  </div>
</div>
